import { render, staticRenderFns } from "./dashboardEfectividad.vue?vue&type=template&id=041a9b98&scoped=true&"
import script from "./dashboardEfectividad.vue?vue&type=script&lang=js&"
export * from "./dashboardEfectividad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041a9b98",
  null
  
)

export default component.exports